import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

interface AutoBrandFromUrlResponse {
  taskId: string;
}

export const useAutoBrandFromUrl = (companyId: string | null | undefined) => {
  const { mutateAsync, isPending } = useMutation<AutoBrandFromUrlResponse, Error, string>({
    mutationFn: async (websiteUrl: string) => {
      const { data } = await api.post<AutoBrandFromUrlResponse>(
        `admin/companies/${companyId}/auto-brand/extract-from-url`,
        { websiteUrl },
      );
      return data;
    },
  });

  return { extractFromUrl: mutateAsync, isExtracting: isPending };
};
